const mediaContext = require.context(
  "../../Assets/Portfolio",
  true,
  /\.(?:jpg|mp4)$/
);

const asset = (path) => mediaContext(`./${path}`);
const localized = (zh, en) => ({ zh, en });

const imageSeries = (folder, count) =>
  Array.from({ length: count }, (_, index) =>
    asset(`${folder}/photo-${String(index + 1).padStart(2, "0")}.jpg`)
  );

const makeAlbum = ({ id, folder, count, cover, title, note }) => {
  const images = imageSeries(folder, count);
  const coverImage = images[cover - 1];
  const orderedImages = [coverImage, ...images.filter((image) => image !== coverImage)];
  return {
    id,
    images: orderedImages,
    cover: coverImage,
    title,
    note,
  };
};

const corporateAlbums = [
  makeAlbum({
    id: "corporate-03",
    folder: "corporate-private/corporate-03",
    count: 11,
    cover: 2,
    title: localized("企業活動 01 · 峰會與晚宴", "Corporate 01 · Summit & gala"),
    note: localized("舞台、席位、品牌畫面與完整會場交付", "Stage, seating, brand environment and venue delivery"),
  }),
  makeAlbum({
    id: "corporate-06",
    folder: "corporate-private/corporate-06",
    count: 7,
    cover: 4,
    title: localized("企業活動 02 · 年度表彰會", "Corporate 02 · Annual recognition"),
    note: localized("簽到、主視覺、展示牆與會場動線", "Check-in, key visuals, display walls and guest flow"),
  }),
  makeAlbum({
    id: "corporate-02",
    folder: "corporate-private/corporate-02",
    count: 6,
    cover: 1,
    title: localized("企業活動 03 · 品牌主題活動", "Corporate 03 · Branded guest event"),
    note: localized("入口、留影區、甜品台與主題佈置", "Entrance, photo area, dessert display and styling"),
  }),
  makeAlbum({
    id: "corporate-01",
    folder: "corporate-private/corporate-01",
    count: 6,
    cover: 4,
    title: localized("企業活動 04 · 專題會議", "Corporate 04 · Industry conference"),
    note: localized("簽到、資料、嘉賓接待與會議現場", "Registration, materials, guest reception and meeting setup"),
  }),
  makeAlbum({
    id: "corporate-05",
    folder: "corporate-private/corporate-05",
    count: 3,
    cover: 2,
    title: localized("企業活動 05 · 親子主題場景", "Corporate 05 · Family-themed activation"),
    note: localized("主題舞台、入口與互動拍照區", "Themed stage, entrance and interactive photo area"),
  }),
  makeAlbum({
    id: "corporate-04",
    folder: "corporate-private/corporate-04",
    count: 2,
    cover: 1,
    title: localized("企業活動 06 · 戶外聚會", "Corporate 06 · Outdoor gathering"),
    note: localized("戶外場地、桌席與互動佈置", "Outdoor setting, tables and interactive installations"),
  }),
];

const proposalAlbums = [
  makeAlbum({
    id: "proposal-07",
    folder: "corporate-private/proposal-07",
    count: 8,
    cover: 6,
    title: localized("求婚策劃 01 · 暖色移動舞台", "Proposal 01 · Warm mobile stage"),
    note: localized("車廂舞台、花藝與夜間燈光", "Truck-stage build, florals and evening lighting"),
  }),
  makeAlbum({
    id: "proposal-03",
    folder: "corporate-private/proposal-03",
    count: 6,
    cover: 2,
    title: localized("求婚策劃 02 · 玫瑰粉夜景", "Proposal 02 · Rose-pink evening"),
    note: localized("禮盒裝置、花藝與照片展示", "Gift-box installation, florals and photo display"),
  }),
  makeAlbum({
    id: "proposal-01",
    folder: "corporate-private/proposal-01",
    count: 3,
    cover: 1,
    title: localized("求婚策劃 03 · 海邊日落", "Proposal 03 · Seaside sunset"),
    note: localized("海岸場地、花藝與燭光動線", "Coastal setting, florals and candlelit approach"),
  }),
  makeAlbum({
    id: "proposal-06",
    folder: "corporate-private/proposal-06",
    count: 7,
    cover: 3,
    title: localized("求婚策劃 04 · 黑白夜景", "Proposal 04 · Monochrome night"),
    note: localized("移動場景、燈牌與儀式細節", "Mobile setting, light signage and ceremony details"),
  }),
  makeAlbum({
    id: "proposal-05",
    folder: "corporate-private/proposal-05",
    count: 6,
    cover: 3,
    title: localized("求婚策劃 05 · 戶外粉色舞台", "Proposal 05 · Pastel outdoor stage"),
    note: localized("主舞台、花牆與入口視覺", "Main stage, flower wall and arrival view"),
  }),
  makeAlbum({
    id: "proposal-02",
    folder: "corporate-private/proposal-02",
    count: 3,
    cover: 1,
    title: localized("求婚策劃 06 · 夜間花園", "Proposal 06 · Night garden"),
    note: localized("燈光裝置與戶外儀式區", "Light installation and outdoor ceremony area"),
  }),
  makeAlbum({
    id: "proposal-04",
    folder: "corporate-private/proposal-04",
    count: 4,
    cover: 1,
    title: localized("求婚策劃 07 · 銀白室內場景", "Proposal 07 · Silver indoor setting"),
    note: localized("氣球、花藝、甜品台與燈光字", "Balloons, florals, dessert display and light signage"),
  }),
];

const birthdayAlbums = [
  makeAlbum({
    id: "birthday-03",
    folder: "corporate-private/birthday-03",
    count: 6,
    cover: 2,
    title: localized("生日派對 01 · 熊貓主題", "Birthday 01 · Panda theme"),
    note: localized("主題牆、甜品台與用餐區", "Feature wall, dessert display and dining area"),
  }),
  makeAlbum({
    id: "birthday-01",
    folder: "corporate-private/birthday-01",
    count: 5,
    cover: 2,
    title: localized("生日派對 02 · 露營主題", "Birthday 02 · Camping theme"),
    note: localized("舞台、帳篷與拍照場景", "Stage, tent and photo setting"),
  }),
  makeAlbum({
    id: "birthday-02",
    folder: "corporate-private/birthday-02",
    count: 5,
    cover: 1,
    title: localized("生日派對 03 · 童話主題", "Birthday 03 · Storybook theme"),
    note: localized("入口、長桌與人物裝置", "Entrance, long table and character installations"),
  }),
];

const weddingAlbums = [
  makeAlbum({
    id: "wedding-03",
    folder: "corporate-private/wedding-03",
    count: 12,
    cover: 3,
    title: localized("婚禮佈置 01 · 綠植沉浸場景", "Wedding 01 · Botanical setting"),
    note: localized("迎賓動線、花藝拱門與宴會空間", "Guest approach, floral arches and banquet environment"),
  }),
  makeAlbum({
    id: "wedding-02",
    folder: "corporate-private/wedding-02",
    count: 6,
    cover: 1,
    title: localized("婚禮佈置 02 · 玫瑰編輯感", "Wedding 02 · Rose editorial"),
    note: localized("主舞台、花藝細節與儀式通道", "Main stage, floral details and ceremony aisle"),
  }),
  makeAlbum({
    id: "wedding-01",
    folder: "corporate-private/wedding-01",
    count: 5,
    cover: 2,
    title: localized("婚禮佈置 03 · 戶外花園", "Wedding 03 · Outdoor garden"),
    note: localized("迎賓牌、儀式區與戶外座席", "Welcome display, ceremony area and outdoor seating"),
  }),
];

const videos = [
  { id: "opening-01", src: asset("corporate-private/videos/opening-01.mp4"), title: localized("開業活動片段", "Opening event highlight"), tag: localized("開業", "Opening") },
  ...Array.from({ length: 4 }, (_, index) => ({
    id: `proposal-video-${index + 1}`,
    src: asset(`corporate-private/videos/proposal-${String(index + 1).padStart(2, "0")}.mp4`),
    title: localized(`求婚活動片段 ${String(index + 1).padStart(2, "0")}`, `Proposal highlight ${String(index + 1).padStart(2, "0")}`),
    tag: localized("求婚", "Proposal"),
  })),
  ...Array.from({ length: 2 }, (_, index) => ({
    id: `birthday-video-${index + 1}`,
    src: asset(`corporate-private/videos/birthday-${String(index + 1).padStart(2, "0")}.mp4`),
    title: localized(`生日活動片段 ${String(index + 1).padStart(2, "0")}`, `Birthday highlight ${String(index + 1).padStart(2, "0")}`),
    tag: localized("生日", "Birthday"),
  })),
  { id: "wedding-video-01", src: asset("corporate-private/videos/wedding-01.mp4"), title: localized("婚禮活動片段", "Wedding highlight"), tag: localized("婚禮", "Wedding") },
];

export const projectCovers = {
  "corporate-private-events": asset("corporate-private/proposal-02/photo-01.jpg"),
  "business-forums": asset("business-forums/photo-03.jpg"),
  "brand-activation": asset("brand-activation/photo-02.jpg"),
  "government-comms": asset("government/public-service/photo-03.jpg"),
  "retail-planning": asset("retail-planning/photo-04.jpg"),
  "property-campaign": asset("property-campaign/photo-03.jpg"),
};

export const projectMedia = {
  "property-campaign": {
    type: "gallery",
    heading: localized("工地宣傳物料", "On-site campaign materials"),
    note: localized("從規格整理、批量製作到現場交付，保留實際完成狀態。", "From specification and batch production to final on-site delivery."),
    images: imageSeries("property-campaign", 12),
  },
  "brand-activation": {
    type: "gallery",
    heading: localized("門店開業現場", "Restaurant opening"),
    note: localized("兩張關鍵畫面分別呈現空間品牌展示及開業儀式。", "Two key views show the branded interior and the opening ceremony."),
    images: imageSeries("brand-activation", 2),
  },
  "retail-planning": {
    type: "gallery",
    heading: localized("商場廣告落地", "Retail campaign delivery"),
    note: localized("涵蓋戶外主視覺、廣場畫面及現場施工交付。", "Outdoor key visuals, plaza placements and on-site installation."),
    images: imageSeries("retail-planning", 4),
  },
  "business-forums": {
    type: "gallery",
    heading: localized("峰會、路演與企業落地", "Summits, roadshows and business landing"),
    note: localized("從國際交流活動到項目簽約，呈現政企對接的不同節點。", "From international exchange events to project signing milestones."),
    images: imageSeries("business-forums", 4),
  },
  "government-comms": {
    type: "sections",
    heading: localized("三個實際交付場景", "Three delivery settings"),
    note: localized("不同公共場景分開展示，呈現每類宣傳與資訊物料的實際落地。", "Each public-facing setting is presented separately to show the delivered campaign and information materials."),
    sections: [
      {
        id: "public-service",
        title: localized("公益宣傳設施", "Public service campaign"),
        note: localized("戶外宣傳欄、分類指引與公共資訊展示", "Outdoor campaign boards, category guidance and public information"),
        images: imageSeries("government/public-service", 5),
      },
      {
        id: "outdoor-wall",
        title: localized("戶外圍牆宣傳", "Outdoor wall campaign"),
        note: localized("社區及園區圍牆畫面製作與現場安裝", "Community and park wall graphics with on-site installation"),
        images: imageSeries("government/outdoor-wall", 5),
      },
      {
        id: "interior",
        title: localized("室內資訊展示", "Interior information display"),
        note: localized("規劃資訊與展示畫面落地", "Planning information and display production"),
        images: imageSeries("government/interior", 1),
      },
    ],
  },
  "corporate-private-events": {
    type: "albums",
    heading: localized("19 場獨立活動", "19 independent events"),
    note: localized("每張封面代表一場獨立活動；點擊後查看該場活動的完整相冊。", "Each cover represents one independent event. Open it to view the complete album."),
    categories: [
      { id: "corporate", title: localized("企業活動", "Corporate"), note: localized("峰會、會議、品牌活動與戶外聚會", "Summits, conferences, brand events and outdoor gatherings"), albums: corporateAlbums },
      { id: "proposal", title: localized("求婚策劃", "Proposals"), note: localized("7 場不同主題與場地的完整佈置", "Seven distinct themes and settings"), albums: proposalAlbums },
      { id: "birthday", title: localized("生日派對", "Birthdays"), note: localized("3 場主題派對與用餐場景", "Three themed parties and dining settings"), albums: birthdayAlbums },
      { id: "wedding", title: localized("婚禮佈置", "Weddings"), note: localized("3 場不同風格的婚禮空間", "Three wedding environments with distinct visual styles"), albums: weddingAlbums },
      { id: "videos", title: localized("獨立影片", "Video highlights"), note: localized("8 段彼此獨立的活動紀錄", "Eight independent event clips"), videos },
    ],
  },
};
